import { strVal } from '../../../../modules/Utils'
import React, { Component } from 'react'
import { Form, Button, Divider, Row, Descriptions } from 'antd'
import { get } from 'lodash'
import CustomTable from '../../../../elements/Table/CustomTable'

class RepresentativeContact extends Component {
  render() {
    const {
      next,
      listExist,
      setRep,
      supplierRegistration,
      type = '',
      path,
      skip,
      setSameRep,
    } = this.props

    return (
      <div className='steps-content'>
        <Descriptions title='Representative Info'>
          {type !== 'representative' && (<Descriptions.Item label='Same as Rep'>
              <Button
                type='primary'
                style={{ marginLeft: 8 }}
                onClick={() => {
                  setSameRep(get(supplierRegistration, `${path}`, {}), type)
                  skip()
                }}>
                Use The Same Representative
              </Button>
            </Descriptions.Item>
          )}
          <Descriptions.Item label='Name'>
            {strVal(supplierRegistration, `${path}.name`)}
          </Descriptions.Item>
          <Descriptions.Item label='Position'>
            {strVal(supplierRegistration, `${path}.position`)}
          </Descriptions.Item>
          <Descriptions.Item label='Email'>
            {strVal(supplierRegistration, `${path}.email`)}
          </Descriptions.Item>
          <Descriptions.Item label='Phone'>
            {strVal(supplierRegistration, `${path}.telephoneNo`)}
          </Descriptions.Item>
          <Descriptions.Item label='Mobile'>
            {strVal(supplierRegistration, `${path}.mobileNo`)}
          </Descriptions.Item>
        </Descriptions>

        <Divider orientation='left'>
          Select From Existing {type !== 'representative' && type} Representative Contact
        </Divider>
        <Row>
          <CustomTable
            data={listExist.reps}
            hide={{ create: true, refresh: true }}
            isFilterable={true}
            defaultFiltered={[
              {
                id: 'fn',
                value: strVal(supplierRegistration, `${path}.name`).substring(0, 7),
              },
            ]}
            columns={[
              {
                Header: 'Name',
                accessor: 'fn',
                width: 250,
              },
              {
                Header: 'Position',
                accessor: 'position',
              },
              {
                Header: 'Mobile Number',
                accessor: 'mobile.label',
              },
              {
                Header: 'Phone Number',
                accessor: 'phone.label',
              },
              {
                Header: 'Email',
                accessor: 'email.label',
              },
              {
                Header: 'Action',
                width: 90,
                Cell: ({ value, original }) => (
                  <Button
                    type='primary'
                    size='small'
                    onClick={() => {
                      setRep(original, type)
                      next()
                    }}>
                    Use This
                  </Button>
                ),
              },
            ]}
          />
        </Row>
      </div>
    )
  }
}

export default RepresentativeContact
